<template>
  <div id="app">
    <OnLoad class="loading" :class="{'is-loading-end': isLoadingEnd}" :is-loading-end="isLoadingEnd"
            v-on:loadCompleted="finishLoad"/>
    <Page :is-loading-end="this.isLoadingEnd" :class="{'is-loading-main animated zoomOut': !isLoadingEnd}"/>
  </div>
</template>

<script>
  import OnLoad from './components/OnLoad';
  import Page from './components/Page';

  export default {
    name: 'App',
    components: {
      OnLoad, Page
    },
    data() {
      return {
        isLoadingEnd: false,
        isAlreadyLoaded: false,
      }
    },
    methods: {
      finishLoad() {
        var timerId = setInterval(() => {
          if (this.isAlreadyLoaded) {
            this.isLoadingEnd = true;
            clearInterval(timerId);
          }
        }, 100);
      }
    },
    mounted() {
      /*
        setTimeout(() => {
          setInterval(() => {
            if (this.isAlreadyLoaded) {
              this.isLoadingEnd = true;
              clearInterval();
            }
          }, 100);
        }, 4200);
      */

      window.onload = () => {
        this.isAlreadyLoaded = true;
        /*
          setTimeout(() => {
            this.isLoadingEnd = true;
          }, 4200);
          */
      }
    }
  };
</script>

<style lang="scss">
  @import "~bulma";

  @font-face {
    font-family: harenosora;
    src: url("./assets/font/Harenosora.otf");
  }

  body {
    font-family: harenosora, serif !important;
  }

  #app {
  }

  .loading {
    position: absolute;
  }

  .is-loading-end {
    opacity: 0;
    transition: opacity 1s;
  }

  .is-loading-main {
    visibility: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue